import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import {
  GetOrganizationResult,
  ORGANIZATION_QUERY_KEY,
  OrganizationsApiResponse,
} from './types';

export const useGetOrganization = (
  documentId: string | null | undefined,
  options?: UseQueryOptions<GetOrganizationResult, AxiosError>,
): UseQueryResult<GetOrganizationResult, AxiosError> => useQuery<GetOrganizationResult, AxiosError>({
  queryKey: ORGANIZATION_QUERY_KEY(documentId || ''),
  queryFn: async (): Promise<GetOrganizationResult> => {
    const res = await axiosInstance.get<OrganizationsApiResponse<GetOrganizationResult>>(
      '/v3-getOrganization',
      { params: { id: documentId } },
    );
    const data = res.data?.data;
    if (!data?.organization) {
      throw new Error('Nieoczekiwany kształt odpowiedzi /v3-getOrganization');
    }
    return data;
  },
  enabled: !!documentId,
  retry: 1,
  staleTime: 1000 * 60 * 2,
  refetchOnWindowFocus: false,
  ...options,
});
